import React, { useEffect, useState } from 'react';
import { Phone, Menu, X, Dumbbell } from 'lucide-react';
import { navLinks, brand } from '../data/mock';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-slate-950/80 backdrop-blur-md border-b border-white/10' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5">
          <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden bg-amber-400 flex items-center justify-center shadow-lg ring-2 ring-amber-400/40">
            <img src={brand.logo} alt="Body Line Gym" className="w-full h-full object-cover" />
          </div>
          <span className="font-anton text-white text-lg md:text-xl tracking-wide">{brand.name}<span className="text-blue-500">.</span></span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {navLinks.map((l) => (
            <a key={l.label} href={l.href} className="text-sm text-white/85 hover:text-white transition-colors relative group">
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-500 group-hover:w-full transition-all duration-300"></span>
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a href="tel:+918482031021" className="inline-flex items-center gap-2 text-white/90 hover:text-white text-sm">
            <Phone className="w-4 h-4" />
            Call
          </a>
          <a href="#plans" className="btn-join-premium inline-flex items-center gap-2 text-sm font-bold px-5 py-2.5">
            Join Today
          </a>
        </div>

        <button onClick={() => setOpen(!open)} className="lg:hidden text-white p-2" aria-label="Menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-slate-950/95 backdrop-blur-lg border-t border-white/10 px-5 py-4">
          <div className="flex flex-col gap-3">
            {navLinks.map((l) => (
              <a key={l.label} href={l.href} onClick={() => setOpen(false)} className="text-white/85 hover:text-blue-400 py-2 border-b border-white/5">
                {l.label}
              </a>
            ))}
            <div className="flex gap-2 pt-3">
              <a href="tel:+918482031021" className="flex-1 inline-flex items-center justify-center gap-2 border border-white/20 text-white text-sm font-semibold px-4 py-2.5 rounded-full">
                <Phone className="w-4 h-4" /> Call
              </a>
              <a href="#plans" onClick={() => setOpen(false)} className="btn-join-premium flex-1 inline-flex items-center justify-center text-sm font-bold px-4 py-2.5">
                Join Today
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
